import styled from 'styled-components';

export const Textarea = styled.textarea`
  height: auto !important;
  resize: none;
  &[disabled] {
    background-color: ${(props) => props.theme.disabledBackground};
  }
`;
